import { Directive, Input } from '@angular/core';

let nextUniqueId = 0;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-hint',
  // `app-hint` kept so the legacy theme styles it.
  host: {
    class: 'app-hint',
    '[class.app-form-field-hint-end]': "align === 'end'",
    '[id]': 'id',
    '[attr.align]': 'null',
  },
})
export class FormFieldHintDirective {
  @Input() align: 'start' | 'end' = 'start';
  @Input() id = `app-form-field-hint-${nextUniqueId++}`;
}
